<template>
    <div class="dsp-title">
        <div class="text-center">
            <div class="dsp-circle" :rate="getRatings"></div>
        </div>
        <div>
            <a class="link" :href="dsp.allSchoolUrl" target="_blank" rel="nofollow">
                <h1 class="f4 singleline"> <b>{{dsp.name}} </b></h1>
            </a>
            <div class="f5 singleline">
                <span> {{dsp.geo.address}}</span>
            </div>
            <div class="f5">
                <a v-if="dsp.geo.city" :href="glb.appUrl + dsp.geo.cityPath">{{ dsp.geo.city }}, {{ dsp.geo.state }}</a>
                <a v-if="dsp.geo.zipcode" :href="glb.appUrl + dsp.geo.zipcodePath">{{ dsp.geo.zipcode }}</a>
            </div>
            <div class="rating">
                <a class="link" href="javascript:void(0)" v-scroll="'reviewsSection'">
                        {{dsp.summary.count}} Reviews
                </a>
                <template v-for="index in 5">
                    <i class="icon-star" v-if="(dsp.summary.avgQuality - index) >= 0 "></i>
                    <i class="icon-star-half" v-else-if="(dsp.summary.avgQuality - index) > -1"></i>
                    <i class="icon-star-o" v-else></i>
                </template>
            </div>
        </div>
    </div>
</template>
<script src="./dsp-title.js"></script>
<style lang="scss">
@use "./dsp-title.scss" as *;
</style>